"use client";

import { c as _c } from "react/compiler-runtime";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import { SortDirection } from "@/entities/ISort";
import { ProfileRatersParamsOrderBy } from "@/enums";
import { useEffect, useState } from "react";
import CommonTableSortIcon from "../icons/CommonTableSortIcon";
export default function ProfileRatersTableHeaderSortableCell(t0) {
  const $ = _c(18);
  const {
    title,
    sortType,
    sortDirection,
    sortOrderBy,
    isLoading,
    onSortTypeClick
  } = t0;
  const [isActive, setIsActive] = useState(sortType === sortOrderBy);
  let t1;
  let t2;
  if ($[0] !== sortOrderBy || $[1] !== sortType) {
    t1 = () => {
      setIsActive(sortType === sortOrderBy);
    };
    t2 = [sortType, sortOrderBy];
    $[0] = sortOrderBy;
    $[1] = sortType;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== onSortTypeClick || $[5] !== sortType) {
    t3 = () => onSortTypeClick(sortType);
    $[4] = onSortTypeClick;
    $[5] = sortType;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `${isActive ? "tw-text-primary-400" : "group-hover:tw-text-iron-200 tw-transition tw-duration-300 tw-ease-out"}`;
  let t5;
  if ($[7] !== t4 || $[8] !== title) {
    t5 = <span className={t4}>{title}</span>;
    $[7] = t4;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isActive || $[11] !== isLoading || $[12] !== sortDirection) {
    t6 = isLoading && isActive ? <span className="tw-pl-2"><CircleLoader size={CircleLoaderSize.SMALL} /></span> : <span className="-tw-mt-0.5 tw-ml-2"><CommonTableSortIcon direction={isActive ? sortDirection : SortDirection.DESC} isActive={isActive} /></span>;
    $[10] = isActive;
    $[11] = isLoading;
    $[12] = sortDirection;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <th onClick={t3} className="tw-group tw-cursor-pointer tw-whitespace-nowrap tw-px-4 sm:tw-px-6 lg:tw-pl-4 tw-py-3.5 tw-text-right tw-text-sm sm:tw-text-md tw-font-medium tw-text-iron-400">{t5}{t6}</th>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}